module.exports = __webpack_public_path__ + "static/images/shelf-big-bg.2a69268.png";